module.exports = __webpack_public_path__ + "01_hair_brown.901c4f98.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/01_hair_brown.png
// module id = 3b28
// module chunks = 0